// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"Reset__materialize-textarea___WRdsz","modal-2463794813":"Reset__modal-2463794813___3uOc4","container":"Reset__container___1uGcy","halfWidthWithSpan":"Reset__halfWidthWithSpan___yrhPY","halfWidthWithSpanError":"Reset__halfWidthWithSpanError___G6YnL","continue":"Reset__continue___2oHlG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ResetPassword/Reset.scss
// module id = 1524
// module chunks = 0